import { graphql } from '@/generated';
export const deleteSitesMutation = graphql(`
  mutation deleteSites($ids: [uuid!]!, $auditLogInput: AuditLogInsertInput!) {
    deleteSite(where: { id: { _in: $ids } }) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createCustomerMutation = graphql(`
  mutation createCustomer(
    $input: CustomerInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertCustomerOne(object: $input) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createSiteMutation = graphql(`
  mutation createSite(
    $inputs: SiteInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertSiteOne(object: $inputs) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const updateCustomerMutation = graphql(`
  mutation updateCustomer(
    $pkColumnInput: CustomerPkColumnsInput!
    $setInput: CustomerSetInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    updateCustomerByPk(pkColumns: $pkColumnInput, _set: $setInput) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createDeviceInBulkMutation = graphql(`
  mutation createDeviceInBulk(
    $deviceInsertInputs: [DeviceInsertInput!]!
    $siteInsertInputs: [SiteInsertInput!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertSite(objects: $siteInsertInputs) {
      affectedRows
    }
    insertDevice(objects: $deviceInsertInputs) {
      returning {
        id
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteCustomerMutation = graphql(`
  mutation deleteCustomer($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
    deleteCustomerByPk(id: $id) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const upsertCustomerS3BucketMutation = graphql(`
  mutation upsertCustomerS3Bucket(
    $customerId: UUID!
    $auditLogInput: AuditLogInsertInput!
  ) {
    upsertCustomerS3Bucket(input: { customerId: $customerId })
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const upsertCustomerSecretMutation = graphql(`
  mutation upsertCustomerSecret(
    $input: UpsertCustomerSecretInput!
    $invalidateCacheInput: InvalidateCustomerSecretCacheInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    upsertCustomerSecret(input: $input) {
      uri
    }
    invalidateCustomerSecretCache(input: $invalidateCacheInput) {
      success
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

// Invalidate cache first because we need to know the arn of the secret.
// There is a slight chance of a race condition, but that will only mean the secret lasts for another TTL.
// And the solution to cache invalidation race in general is to move the invalidation timestamp slightly into the future.
export const deleteCustomerSecretMutation = graphql(`
  mutation deleteCustomerSecret(
    $input: DeleteCustomerSecretInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    deleteCustomerSecret(input: $input) {
      name
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createCustomerApiKeysMutation = graphql(`
  mutation createCustomerApiKeysMutation(
    $input: CreateCustomerApiKeysInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    createCustomerApiKeys(input: $input) {
      apiKeys {
        customerId
        key
        reference
        roleId
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);
